import { render, staticRenderFns } from "./DeviceTransfer.vue?vue&type=template&id=f8f86bfc&"
import script from "./DeviceTransfer.vue?vue&type=script&lang=js&"
export * from "./DeviceTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports